<template>
    <div class="main" id="projects">
      
  <div class="container mt-5">
     <div class="container">
      <h1 class="display-2 text-mono">Projects</h1>
        <div class="lead mb-2 text-mono text-success" id="subheader" style="font-size: 1rem">  
          <h5>github-repositories</h5>
        </div>   

<hr>

<div class="container mt-5">
  <div class="row justify-content-center">
    
  <div class="col-xl-5">
   <div class="item"><span class="badge badge-info notify-badge">Prime Workshop!</span>
     <div>    
<a href="https://github.com/dinogomez/Prime-Workshop-2020" >
   <img class="btn btn-primary btn-shadow " src="https://github-readme-stats.vercel.app/api/pin/?username=dinogomez&repo=Prime-Workshop-2020&theme=dark&hide_border=true&bg_color=714cdf&text_color=FFFFFF" alt="Timediff.js"  style=""/>
  </a></div></div>
   
  </div>
  
  
    <div class="col-xl-5" style="">
        
<div class="item">
     <div>    
<a href="https://dinogomez.github.io/Timediff.js" ><span class="badge badge-js notify-badge">Javascript</span>
   <img class="btn btn-primary btn-shadow" src="https://github-readme-stats.vercel.app/api/pin/?username=dinogomez&repo=Timediff.js&theme=dark&hide_border=true&bg_color=714cdf&text_color=FFFFFF" alt="Timediff.js"  style=""/>
  </a></div></div>
  
  </div>

</div>

<div class="row justify-content-center">
    
  <div class="col-xl-5">
   <div class="item"><span class="badge badge-php notify-badge">PHP</span>
     <div>    
<a href="https://github.com/dinogomez/depot" >
   <img class="btn btn-primary btn-shadow " src="https://github-readme-stats.vercel.app/api/pin/?username=dinogomez&repo=depot&theme=dark&hide_border=true&bg_color=714cdf&text_color=F1F1F1" alt="depot"  style=""/>
  </a></div></div>
   
  </div>
  
  
    <div class="col-xl-5" style="">
        
<div class="item">
     <div>    
<a href="https://github.com/dinogomez/eve" ><span class="badge badge-php notify-badge" style="">PHP</span>
   <img class="btn btn-primary btn-shadow" src="https://github-readme-stats.vercel.app/api/pin/?username=dinogomez&repo=eve&theme=dark&hide_border=true&bg_color=714cdf&text_color=FFFFFF" alt="eve"  style=""/>
  </a></div></div>
  
  </div>

</div>




</div>


  </div>

     </div>
    </div>
    
</template>

<script>



export default {
    name: "Main",
    methods: {}
}
</script>
<style scoped >
.badge-js{
  background: #f7df1e;
  color: #191919 !important;
  }
.badge-php{
    background: #4f5b93;
    width: 25%;
}


.item {
    padding-top:20px;
    display:inline-block;
}
.notify-badge{
    position: absolute;
    right:-20px;
    top:10px;
    text-align: center;
    border-radius: 30px 30px 30px 30px;
    color:white;
    padding:5px 10px;
    font-size:20px;
        z-index: 99999999;

}

    hr{
              background-color: #ccc;

    }
    #avatar{
        border-radius: 10%;
          box-shadow: 5px 10px #6f42c1;

    }
    #Paul{
        word-spacing: -1rem;
    }
    .main{
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center; 
        
    }
</style>